<div [ngClass]="['notification-severity-ball', $severity()]"></div>
